import React, { useContext, useEffect, useState } from "react";
import { navigate } from "gatsby";
import moment from "moment";
import GlobalContext from "../../../contexts/globalContext";
import { saveForm, getToken, getUserFormDataByQuestionId, getCursosData } from "../../../services/formServices";
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

// Components //
import FormHead from "../../molecules/form-head/FormHead";
import FormBody from "../../molecules/form-body/FormBody";
import Button from "../../atoms/button/button";
import Modal from "../../ui/modal/Modal";

// Utils //
import rawToReact from "../../../utils/rawToReact";
import { convertArrayToObject } from "../../../utils/helpers";

import competenciaEmocionalSVG from "../../../../src/assets/images/icons/competencia-emocional.svg";
import competenciaEspecificaSVG from "../../../../src/assets/images/icons/competencia-especifica.svg";

// Styles //
import "./FormCursoAprendizaje.scss";
import iconInfo from '../../../assets/images/icons/icon-lilac.svg';
import { FormCursosAprendizajeQuery } from "./queryContentful/FormCursosAprendizajeQuery";

interface ISelectedRole {
   title: string;
   icon?: string;
   iconDark?: string;
   nombreId: string;
}

const FormCursoAprendizaje = (props: any) =>{

    const data = FormCursosAprendizajeQuery();
    const contentfulData = data.form.nodes[0];
    const contentfulModalSuccess = data.modalSuccess.nodes[0];
    const contentfulModalNoInterest = data.modalNointerest.nodes[0];
    const Context = useContext(GlobalContext);

    const [formValues, setFormValues] = useState<any>({});
    const [copyFormValues, setCopyFormValues] = useState<any>({});
    const [isOpenModalSuccess, setIsOpenModalSuccess] = useState<boolean>(false);
    const [isOpenModalNoInterest, setIsOpenModalNoInterest] = useState<boolean>(false);
    const [isShowForm, setIsShowForm] = useState<boolean>(true);
    const [, setDeletedRole] = useState("");
    const [inputDisabled, setInputDisabled] = useState<string[]>([]);
    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [selectedRole, setSelectedRole] = useState<ISelectedRole>();
    const [selectedRole2, setSelectedRole2] = useState<ISelectedRole>();
    const [selectedSpecific, setSelectedSpecific] = useState<ISelectedRole>();
    const [, setModeSpecific] = useState<string>("");
    const [, setModeSpecific2] = useState<string>("");
    const [fieldsToSkip, setFieldsToSkip] = useState<string[]>([]);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [, setTitleCourse] = useState<string>("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [disability, setDisability] = useState("NO");
    const [active, setActive] = useState("");
    const [optionEdit, setOptionEdit] = useState<boolean>(false);
    const [adviceModality, setAdviceModality] = useState<boolean>(false);
    const hiddenFields = {
        ["inscrito_mentoria"]: "",
        ["asistencia_mentoria"]: "",
        ["fecha_mentoria"]: "",
        ["mentor"]: "",
        ["ccf_comfama"]: "",
        ["tipo_tit"]: "",
        ["tiempo_cotizacion"]: "",
        ["beneficio_economico"]: "",
        ["contributionFee"]: "",
    };

    const [cancelForm, setCancelForm] = useState(false);
    const [dataTitulos, setDataTitulos] = useState(contentfulData.titulosFormulario);
    const [isFirstTimeCourses, setIsFirstTimeCourses] = useState<boolean>(false);


    const inputsForm = contentfulData.titulosFormulario[0].referenciaFormulario;
    const inputsForm1 = contentfulData.titulosFormulario[1].referenciaFormulario;
    const inputsForms3 = contentfulData.titulosFormulario[2].referenciaFormulario;

    const registerDate = moment(Date.now()).format("DD-MM-YYYY");
    const fieldsToSkipAux: string[] = [...fieldsToSkip];
    const roles2Obj = convertArrayToObject(contentfulData.titulosFormulario[2].referenciaFormulario.slice(0),"nombreId");
    const roles1Obj = convertArrayToObject(contentfulData.titulosFormulario[0].referenciaFormulario.slice(1),"nombreId");
    const rolesObj = Object.assign({}, roles1Obj, roles2Obj);
    const specificSkillsObj = convertArrayToObject(contentfulData.titulosFormulario[1].referenciaFormulario.slice(1),"nombreId");
    const storedDisability = localStorage.getItem('disability');


    // lista de roles profesionales

    let roles = inputsForm.filter(obj => obj.nombreId.startsWith('role_')).map(obj => obj.nombreId.toString());
    const array = inputsForms3.map((input) => input.nombreId.toString());
    roles = roles.concat(array);
    // lista de componetencias específicas
    const specificSkills = inputsForm1.slice(1).map((input) =>  input.nombreId.toString());


    let selectorReasonOptionsSpecific: any = null;
    let selectorAnotherReasonSpecific: any = null;

    useEffect(() => {
        selectorReasonOptionsSpecific = document.querySelector(".a-input__form-reason_not_interested_specific");
        selectorAnotherReasonSpecific = document.querySelector(".a-input__form-another_reason_specific");
    }, [formValues])

    const getActiveIndex = (index: number):void => {
        setActiveIndex(index)
    }

    const changeDisplayElement = (arrayElements: string[], classElement: string, valueMode: string) => {
      arrayElements.forEach((selector: string) =>{
            const elementDiv = document.querySelector(selector) as HTMLElement;
            if (valueMode !== "") {
                if (classElement === selector) {
                    elementDiv.style.display = "flex";
                } else {
                    elementDiv.style.display = "none";
                }
            } else {
                elementDiv.style.display = "none";
            }
        })
    }

    //Validaciones para los inputs
    const validationField = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "nameContact" || field === "role") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "phone") {
            return value.length <= 10 ? true : false;
        } else if (field === "observations") {
            return value.length <= 400 ? true : false;
        }
        return true;
    };

    // Validacion para los Roles Profesionales
    const formValuesValidation = (rolesArray: [], selectedRoleField: string, isActive: boolean, obj) => {
        const auxFormValues = { ...formValues };
        rolesArray.forEach((role) => {
            if (auxFormValues[role]) {
                delete auxFormValues[role];
            }
        });
        if (isActive && typeof isActive === "boolean") {
            auxFormValues[selectedRoleField] = obj[selectedRoleField].tituloBotonTerminos;
        } else {
            auxFormValues[selectedRoleField] = isActive;
        }

        setFormValues(auxFormValues)
    }

    const formValuesSkipped = (rolesArray: [], value: string) => {

      rolesArray.forEach((item: string) => {
            if (item !== value) {
                fieldsToSkipAux.push(item);
            }
        })
    }

    useEffect(() => {
            const docNumber = localStorage.getItem('docNumber');
            if (storedDisability && storedDisability !== "NO") {
                setDisability(storedDisability);

                // Lista de discapacidades con los mismos campos por ocultar
                const disabilitiesToHideFields = ["Auditiva", "Cognitiva", "Aprendizaje", "Psicosocial", "Múltiple", "Orgánica"];
                // lista de index [titulosFormularios, referenciaFormulario] en contentful
                const fieldsToHide = [
                    [0, 3], [0, 5], [0, 7],
                    [2, 2], [2, 3], [2, 6]
                ];

                // check de la lista de discapacidades si hace match con la variable storedDisability se ocultan los fieldToHide
                if (disabilitiesToHideFields.includes(storedDisability)) {
                    fieldsToHide.forEach(([formIndex, fieldIndex]) => {
                        contentfulData.titulosFormulario[formIndex].referenciaFormulario[fieldIndex].tipoCampo = 'hidden';
                    });
                    setDataTitulos(modifyArray(contentfulData.titulosFormulario));
                } else if (storedDisability === "Visual") {
                    const visualFieldsToHide = [
                        [0, 7], [2, 6]
                    ];

                    visualFieldsToHide.forEach(([formIndex, fieldIndex]) => {
                        contentfulData.titulosFormulario[formIndex].referenciaFormulario[fieldIndex].tipoCampo = 'hidden';
                    });
                    setDataTitulos(modifyArray(contentfulData.titulosFormulario));
                }
            } else {
                setDisability("Ninguna");
            }

            if (docNumber != undefined) {
                const getAnswersByDocNumber = async () => {
                    const token = await getToken();
                    return getUserFormDataByQuestionId(token, 6, "docNumber", docNumber );
                };

                getAnswersByDocNumber().then(response => {
                    delete response.data.answerData.workshop_offer;
                    delete response.data.answerData.doc_number;
                    delete response.data.answerData.document_type;
                    delete response.data.answerData.municipality_of_residence;
                    setFormValues({...formValues, ...response.data.answerData, ...hiddenFields, ["registerDate"]: registerDate})
                })
            } else {
                navigate(props.location.href.replace("/aprendizaje/formulario/cursos/","/aprendizaje/formulario/talleres/"));
            }
        }, [])


    useEffect(() => {
        if (selectedRole?.nombreId) {
            formValuesSkipped(roles, selectedRole?.nombreId);
            setFormValues({ ...formValues});
        }

        // ACTUALIZAR ESTA PARTE PARA QUE CAMBIE BN EL TITULO BASADO EN CURRENTINDEX

        if (activeIndex == 1){
            setTitleCourse("Cursos de competencias específicas para ")
        } else if (activeIndex == 2 && selectedRole?.title == "Perfil para el autoempleo"){
            setTitleCourse("Cursos de competencias claves y transversales ")
        } else if (activeIndex == 2){
            setTitleCourse("Cursos de competencias socioemocionales para ")
        }
    }, [activeIndex]);

    // Actualiza los valores de los campos diligenciados por el usuario
    const updateInputValue = async (field: string, value: any, type?: string) => {
        const token = await getToken();
        const anotherReasonSpecificElement : any = document.querySelector(".a-input__form-another_reason_specific");

        if (validationField(field,value)){
            setFormValues((prev: any) => {
                return { ...prev, [field]: value };
            });
        }

        //IMPORTANTE LINEA
        if (roles.includes(field)) {
            contentfulData.titulosFormulario[1].referenciaFormulario[1].listaSelect = [];
            contentfulData.titulosFormulario[3].referenciaFormulario[1].listaSelect = [];

            if (disability === "Física" || disability === "NO") {
                contentfulData.titulosFormulario[2].referenciaFormulario[1].listaSelect = [];
                contentfulData.titulosFormulario[2].referenciaFormulario[2].listaSelect = [];
            }
            formValuesValidation(roles, field, value, rolesObj);
            formValuesSkipped(roles, field);
            if((field.match(/_/g) || []).length === 1){
                setSelectedRole({
                    title: rolesObj[field].tituloBotonTerminos,
                    icon: rolesObj[field].icon.file.url,
                    iconDark: rolesObj[field].iconDark.file.url,
                    nombreId: rolesObj[field].nombreId
                });
                roles.forEach((item: string) => {

                    if (item !== field) {

                        setFormValues((prev: any) => {
                            return { ...prev, [item]: " " };
                        });
                    }
                })
            }

            if((field.match(/_/g) || []).length === 2){
                setSelectedRole2({
                    title: roles2Obj[field].tituloBotonTerminos,
                    icon: roles2Obj[field].icon ? rolesObj[field].icon.file.url : null,
                    iconDark: roles2Obj[field].iconDark ? rolesObj[field].iconDark.file.url : null,
                    nombreId: roles2Obj[field].nombreId
                });
                roles.forEach((item: string) => {
                     setDeletedRole(item);
                    if (item !== field) {
                        setFormValues((prev: any) => {
                            return { ...prev, [item]: " " };
                        });
                    }
                });
            }
        }

        if (specificSkills.includes(field) && field === "specific_curso") {
            if (value !== selectedSpecific?.title) {
                formValuesValidation(specificSkills, field, value, specificSkillsObj);
                formValuesSkipped(specificSkills, field);
                setSelectedSpecific({
                    title: value,
                    nombreId: specificSkillsObj[field].nombreId
                });
            }
        }


        if (field === "modeSpecific"){
            if(value != "") {
                getCursosData(selectedRole?.title, value, disability, token).then(coursesData => {

                    const optionsList = coursesData.data.map(item => item.course);
                    if (coursesData.data.length === 1){
                        setAdviceModality(true);
                        contentfulData.titulosFormulario[1].referenciaFormulario[1].listaSelect = optionsList;
                        setFormValues((prev: any) => {
                            return { ...prev, [field]: value };
                        });
                    } else {
                        setAdviceModality(false);
                        contentfulData.titulosFormulario[1].referenciaFormulario[1].listaSelect = optionsList;
                        setFormValues((prev: any) => {
                            return { ...prev, [field]: value };
                        });
                    }
                })
            } else {
                contentfulData.titulosFormulario[1].referenciaFormulario[1].listaSelect = [];
                setFormValues((prev: any) => {
                    return { ...prev, [field]: value };
                });
            }
            setCopyFormValues(formValues);
            setModeSpecific(value);

        }
        if(field === "modeSpecific2"){
            if(value !== ""){
                getCursosData(selectedRole2?.title, value, disability, token).then(coursesData => {
                    const optionsList = coursesData.data.map(item => item.course);
                    const finalList = optionsList.filter(item => item !== formValues.specific_curso);
                    if(finalList.length === 1){
                        setAdviceModality(true);
                        contentfulData.titulosFormulario[3].referenciaFormulario[1].listaSelect = finalList;
                        setFormValues((prev: any) => {
                            return { ...prev, [field]: value };
                        });
                    } else {
                        setAdviceModality(false);
                        contentfulData.titulosFormulario[3].referenciaFormulario[1].listaSelect = finalList;
                        setFormValues((prev: any) => {
                            return { ...prev, [field]: value };
                        });
                    }
                });
            }else{
                contentfulData.titulosFormulario[1].referenciaFormulario[1].listaSelect = [];
                setFormValues((prev: any) => {
                    return { ...prev, [field]: value };
                });
                setAdviceModality(false);
            }
            setModeSpecific2(value);
        }


        if(field === "specific_curso_2"){
            if(value === "No me interesa"){
                document.querySelector(".a-input__form-reason_not_interested_specific_2").style.display = "flex";
            }else{
                document.querySelector(".a-input__form-reason_not_interested_specific_2").style.display = "none";
                document.querySelector(".a-input__form-another_reason_specific_2").style.display = "none";
            }
        }

        if(field === "reason_not_interested_specific_2"){
            if(value === "Otra"){
                document.querySelector(".a-input__form-another_reason_specific_2").style.display = "flex";
            }else{
                document.querySelector(".a-input__form-another_reason_specific_2").style.display = "none";
            }
        }

        if (field == "reason_not_interested_specific") {
            formValues.another_reason_specific = " ";
            if (value == "Otra") {
                anotherReasonSpecificElement.style.display = "flex";

                if (document.getElementById("text-area-another_reason_specific").value === "") {
                    setDisabledButton(true);
                }

            } else {
                anotherReasonSpecificElement.style.display = "none";
                document.getElementById("text-area-another_reason_specific").value = "";
                fieldsToSkipAux.push("another_reason_specific");

                setDisabledButton(false);
            }
        }

        if (field === "another_reason_specific") {
            if (value === "") {
                setDisabledButton(true);
            } else {
                setDisabledButton(false);
            }
        }

        setFieldsToSkip(fieldsToSkipAux);
    };

    const modifyArray = (dataArray) => {
        return dataArray.filter(item => item.contentful_id !== "UN3bn13P2P8JL8vWcmSdM");
    };

    useEffect(() => {
        if (selectedSpecific?.title === "No me interesa") {
            setDisabledButton(true);
        } else {
            fieldsToSkipAux.push("another_reason_specific");
            fieldsToSkipAux.push("reason_not_interested_specific");
            setDisabledButton(false);
        }
    }, [selectedSpecific])


    useEffect(() => {
      if(currentIndex === 2 || currentIndex === 3 || currentIndex === 4){
         setActive("m-form-head-opcion__content");
      }else{
         setActive("m-form-head-opcion__content__option-two");
      }
      setAdviceModality(false);
    }, [currentIndex]);

    useEffect(() => {
        selectorReasonOptionsSpecific = document.querySelector(".a-input__form-reason_not_interested_specific");
        selectorAnotherReasonSpecific = document.querySelector(".a-input__form-another_reason_specific");

        if (selectedSpecific?.title === "No me interesa") {
         if (selectorReasonOptionsSpecific) {
               selectorReasonOptionsSpecific.style.display = "flex";
         }
        } else {
            if (selectorReasonOptionsSpecific) {
                selectorReasonOptionsSpecific.style.display = "none";
                formValues.reason_not_interested_specific = " ";
                fieldsToSkipAux.push("reason_not_interested_specific");
            }
            if (selectorAnotherReasonSpecific) {
                selectorAnotherReasonSpecific.style.display = "none";
                formValues.another_reason_specific = " ";
                document.getElementById("text-area-another_reason_specific").value = "";
                fieldsToSkipAux.push("another_reason_specific");
            }
        }
    }, [selectedSpecific]);

    useEffect(() => {
        selectorReasonOptionsSpecific = document.querySelector(".a-input__form-reason_not_interested_specific");
        selectorAnotherReasonSpecific = document.querySelector(".a-input__form-another_reason_specific");

        if (currentIndex == 1) {
            if (formValues.specific_curso && formValues.specific_curso === "No me interesa") {
                selectorReasonOptionsSpecific.style.display = "flex";

                if (formValues.reason_not_interested_specific === "Otra") {
                    selectorAnotherReasonSpecific.style.display = "flex";
                }
            } else {
                formValues.reason_not_interested_specific = " ";
                formValues.another_reason_specific = " ";
            }
        }

    }, [currentIndex, formValues.specific_curso]);

    const createPayload = () => {
        const payload: any = {
            idForm: 8,
            answers: [],
        };
        if(disability !== ""){
            delete copyFormValues.modeSpecific;
        }
        const payloadObj = combineObjects(formValues, copyFormValues);
        delete payloadObj.reason_not_interested;
        delete payloadObj.another_reason;
        Object.entries(payloadObj).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });

        return payload;
    };

    function combineObjects(formValuesObj, copyFormValuesObj) {
        const combined = {};

        for (let key in formValuesObj) {
            if (formValuesObj.hasOwnProperty(key)) {
                if (copyFormValuesObj.hasOwnProperty(key)) {
                    const val1 = formValuesObj[key]?.trim();
                    const val2 = copyFormValuesObj[key]?.trim();

                    if (
                        formValuesObj[key] !== copyFormValuesObj[key] &&
                        val1 !== "" &&
                        val2 !== ""
                    ) {
                        if (key === "specific_curso") {
                            combined[key] = formValuesObj[key]; // <-- Aquí solo tomamos el valor 1
                        } else {
                            combined[key] = [
                                formValuesObj[key],
                                copyFormValuesObj[key],
                            ];
                        }
                    } else if (val1 !== "" && val2 === "") {
                        combined[key] = formValuesObj[key];
                    } else {
                        combined[key] = copyFormValuesObj[key];
                    }
                } else {
                    combined[key] = formValuesObj[key];
                }
            }
        }

    for (let key in copyFormValuesObj) {
        if (copyFormValuesObj.hasOwnProperty(key) && !combined.hasOwnProperty(key)) {
            combined[key] = copyFormValuesObj[key];
        }
    }
        return combined;
    }

    const handleSubmitForm = async () => {

        const token = await getToken();
        setDisabledButton(true);
        if ((formValues.specific_curso === "No me interesa" && formValues.isInterested === "No")) {
            setIsOpenModalNoInterest(true);
            setIsShowForm(false);
            const payload = createPayload();
            const response = await saveForm(payload, token);
            const dataSavedSuccess = response.data?.status === 200 || response.data?.status === 201;
            if (response.status == 200 && dataSavedSuccess) {
                localStorage.removeItem("docNumber");
                localStorage.removeItem("disability");
            }
            setDisabledButton(false);
        } else {
            setIsOpenModalSuccess(true);
            setIsShowForm(false);
            const payload = createPayload();
            const response = await saveForm(payload, token);
            const dataSavedSuccess = response.data?.status === 200 || response.data?.status === 201;
            if (response.status == 200 && dataSavedSuccess) {
                localStorage.removeItem("docNumber");
                localStorage.removeItem("disability");
            }
            setDisabledButton(false);
        }
    };

    const closeForm = () => {
        navigate(`https://www.comfama.com/servicio-de-empleo/personas/`);
    };

    const ChildHeader: React.FC = () => {
       if (currentIndex === 1 || currentIndex === 3){
            return <>
                <>
                    <div>
                        <div className="child-header-container">
                            <img src="https://images.ctfassets.net/203frbsx1z3n/7smSES1AclVuOCzk12tkpg/4c38b0b5f9173600b11f2a1602e63026/computadora__1_.svg"/>
                            <p className="child-header-container__text">Recuerde que para tomar un curso en <strong>modalidad virtual</strong> necesitas acceso a internet y un dispositivo como una computadora o un celular para conectarte.</p>
                        </div>
                        <div className="child-header-container">
                            <img src="https://images.ctfassets.net/203frbsx1z3n/2X5mCTar7xIsrCsF2L3Xn3/58b53a749c925d0ce7e59493695f9d3a/libro-alt__3_.svg"/>
                            <p className="child-header-container__text">Para la <strong>modalidad presencial</strong> es importante que dispongas de tiempo y recursos para desplazarte al lugar en el que se dictará la formación.</p>
                        </div>
                    </div>
                    {adviceModality && (
                        <div className="child-header-modalityWithoutCourses">
                            <p>
                                En esta modalidad actualmente no hay cursos disponibles. Revisa nuevamente la oferta y selecciona un curso en otra modalidad.
                            </p>
                        </div>
                    )}
                </>
            </>
        } else if(currentIndex === 4){
            return <>
                <div className="child-header-container-gif">
                    <div className="child-header-container-gif__icon">
                        <img className="child-header-container-gif__icon--light"
                            src="https://images.ctfassets.net/203frbsx1z3n/4sg11L4g2lwFmabgf2G9ja/fa3b94eccc9611dbade84a78e6ec0744/pregunta.gif"
                            alt={"Gif signo de pregunta"}
                        />
                        <img className="child-header-container-gif__icon--dark"
                            src="https://images.ctfassets.net/203frbsx1z3n/1tbMwea2oV9UzYatGUro0H/a90464c52d3d011eff3d54010e61960c/pregunta_FondoDark.gif"
                            alt={"Gif signo de pregunta"}
                        />
                    </div>
                    <h3>Antes de finalizar nos gustaría saber</h3>
                </div>
            </>
        }
        return null;
    }

    useEffect(() => {
        if (Context.gigyaContext.gigyaAccount) {
            setFormValues({
                ...formValues,
                nameContact:
                    Context.gigyaContext.gigyaAccount.profile.firstName +
                    " " +
                    Context.gigyaContext.gigyaAccount.profile.lastName,
                email: Context.gigyaContext.gigyaAccount.profile.email,
                mobile: Context.gigyaContext.gigyaAccount.data.mobile,
                phone: Context.gigyaContext.gigyaAccount.data.phone,
            });
            setInputDisabled(["fullName", "email"]);
        } else {
            setInputDisabled([]);
        }
    }, [Context.gigyaContext.gigyaAccount]);

    const handleCancel = () =>{
        setCancelForm(true);
    }

    const closeCancelModal = () => {
        navigate(`https://www.comfama.com/trabajo-con-proposito/empleo/aprendizaje-y-desarrollo/`);
    };

    const closeCancelForm = () => {
        setCancelForm(false);
    };

    const closeNoticeModal = () => {
        setIsFirstTimeCourses(false);
    };

    const handleClickEdit = (number) => {
   //
        setDisabledButton(true);
        setCurrentIndex(number);
        setActiveIndex(number);
        setOptionEdit(true);
        if (number === 0) {

            setSelectedRole({
                title: '',
                icon: '',
                iconDark: '',
                nombreId: ''
            });
            setFormValues((prev: any) => {
                return { ...prev,
                    specific_curso : '',
                    modeSpecific : '',
                    role_1 : '',
                    role_2 : '',
                    role_3 : '',
                    role_4 : '',
                    role_5 :'',
                    reason_not_interested_specific : '',
                    another_reason_specific : '',
                    modeSpecific2 : '',
                    specific_curso_2 : '',
                    role_1_1 : '',
                    role_2_1 : '',
                    role_3_1 : '',
                    role_4_1 : '',
                    role_5_1 : '',
                };
            });
            setCopyFormValues({})
        } else {
            setFormValues((prev: any) => {
                return { ...prev,
                    modeSpecific2 : '',
                    specific_curso_2 : '',
                    role_1_1 : '',
                    role_2_1 : '',
                    role_3_1 : '',
                    role_4_1 : '',
                    role_5_1 : '',
                };
            });
        }
        setSelectedRole2({
            title: '',
            icon: '',
            iconDark: '',
            nombreId: ''
        });
    };

    useEffect(() => {
        if(currentIndex === 2 && formValues.specific_curso === 'No me interesa' && formValues.reason_not_interested_specific !== ""){
            setCurrentIndex(4);
            setActiveIndex(4);
            setOptionEdit(true);
        }
    }, [currentIndex]);

    useEffect(() => {
        if(selectedRole){
            if(selectedRole.title !== ""){
                setDisabledButton(false);
            }
        }
    }, [selectedRole]);

    return (
        <>
            {isShowForm && (
                <div className="o-form-cursoAprendizaje">
                    <>
                        <FormHead
                            tituloPrincipal={contentfulData.tituloPrincipal}
                            descripcion={contentfulData.descripcion}
                            tituloFormulario={contentfulData.tituloFormulario}
                        ></FormHead>
                        <div className="m-form-head-oferta">
                            <div className="m-form-head-oferta__title-container">
                                <h3 className="title">Oferta de cursos</h3>
                            </div>
                            <div className="m-form-head-oferta__body-container">
                                <p className="body-paraph">
                                    Para tu experiencia de aprendizaje tienes <strong>dos opciones de cursos</strong>, podrás acceder a la segunda opción de cursos en caso de
                                    que tu primera elección no esté disponible.
                                </p>
                            </div>
                        </div>
                        <div className="m-form-head-opcion">
                            <div className="m-form-head-opcion__container">
                                <p className="m-form-head-opcion__number">Opción 1</p>
                                <div className={currentIndex > 1 ? "m-form-head-opcion__content-borderless": "m-form-head-opcion__content"}>
                                    <div className="m-form-head-opcion__content__enfoque">
                                        <img src="https://images.ctfassets.net/203frbsx1z3n/7d4zBo6vAa2arSJvXrhrG0/166daedcedbadfbff8b6b116a8a8d009/usuario__3_.svg"/>
                                        <h3>Enfoque:</h3>
                                        <p>{selectedRole?.title ? selectedRole?.title : '-'}</p>
                                    </div>
                                    <div className="m-form-head-opcion__content__modalidad">
                                        <img src="https://images.ctfassets.net/203frbsx1z3n/53LVqsNG2y4TchNxmioPhG/c225d92c489b71b2f652be91c67aa774/aprendizaje-electronico__1_.svg"/>
                                        <h3>Modalidad:</h3>
                                        <p>{formValues.modeSpecific ? formValues.modeSpecific : '-'}</p>
                                    </div>
                                    <div className="m-form-head-opcion__content__curso">
                                        <img src="https://images.ctfassets.net/203frbsx1z3n/4YjWklo6R4Gh2AWQ19uUBz/ed1839d398fa7fbe312a9a195ae14ed4/Icon_Aprendizajr.svg"/>
                                        <h3>Curso:</h3>
                                        <p>{formValues.specific_curso ? formValues.specific_curso.split("/")[0] : '-'}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="m-form-head-opcion__container">
                                <p className="m-form-head-opcion__number">Opción 2</p>
                                <div className={active}>
                                    <div className="m-form-head-opcion__content__enfoque">
                                        <img src="https://images.ctfassets.net/203frbsx1z3n/7d4zBo6vAa2arSJvXrhrG0/166daedcedbadfbff8b6b116a8a8d009/usuario__3_.svg"/>
                                        <h3>Enfoque:</h3>
                                        <p>{selectedRole2?.title ? selectedRole2?.title : '-'}</p>
                                    </div>
                                    <div className="m-form-head-opcion__content__modalidad">
                                        <img src="https://images.ctfassets.net/203frbsx1z3n/53LVqsNG2y4TchNxmioPhG/c225d92c489b71b2f652be91c67aa774/aprendizaje-electronico__1_.svg"/>
                                        <h3>Modalidad:</h3>
                                        <p>{formValues.modeSpecific2 ? formValues.modeSpecific2 : '-'}</p>
                                    </div>
                                    <div className="m-form-head-opcion__content__curso">
                                        <img src="https://images.ctfassets.net/203frbsx1z3n/4YjWklo6R4Gh2AWQ19uUBz/ed1839d398fa7fbe312a9a195ae14ed4/Icon_Aprendizajr.svg"/>
                                        <h3>Curso:</h3>
                                        <p>{formValues.specific_curso_2 ? formValues.specific_curso_2.split("/")[0] : "-"}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <FormBody
                            titulosFormulario={dataTitulos}
                            tituloBoton={contentfulData.tituloBoton}
                            genericClassNameForm={contentfulData.metaTitulo}
                            setInputValue={updateInputValue}
                            formValues={formValues}
                            handleSubmitForm={handleSubmitForm}
                            inputDisabled={inputDisabled}
                            isDisabledButton={isDisabledButton}
                            fieldsToSkip={fieldsToSkip}
                            childHeader={<ChildHeader/>}
                            getActiveIndex={getActiveIndex}
                            setCurrentIndex={setCurrentIndex}
                            optionEdit={optionEdit}
                            setOptionEdit={setOptionEdit}
                            positionIndex={currentIndex}
                        >
                           {currentIndex > 0 && (

                           <button className="button-editar" onClick={()=> handleClickEdit(0)}>
                              Volver
                           </button>
                        )}
                           <button
                              className={`boton-cancelar`}
                              onClick={() => handleCancel()}
                           >
                                 Cancelar
                           </button>
                            {cancelForm && (
                             <Modal
                             showModal={cancelForm}
                             onClose={closeCancelForm}>
                                 <div
                                     className={`m-modal-container-validation`}
                                 >
                                     <h3>¿Estás seguro que quieres cancelar el proceso de inscripción?</h3>
                                     <div className="a-button-magenta-container__modal-cancelar">
                                         <Button
                                            type="button"
                                            classname="a-button-magenta"
                                            text={"NO, QUIERO REGRESAR"}
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeCancelForm()
                                            }}
                                         >
                                         </Button>
                                     </div>
                                     <div>
                                     <Button
                                            type="button"
                                            classname="a-button-magenta__cancelar-modal"
                                            text={"SÍ QUIERO"}
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeCancelModal()
                                            }}
                                            >
                                    </Button>
                                     </div>
                                 </div>
                         </Modal>
                        )}
                        {/* Modal de inicio de cursos */}
                        {isFirstTimeCourses && (disability === "Física" || disability === "NO") && (
                            <Modal
                                showModal={isFirstTimeCourses}
                                onClose={closeNoticeModal}>
                                <div className={`m-modal-container-validation`}>
                                    <div className="notice-title">
                                        <h3>Importante</h3>
                                    </div>
                                    <div className="notice-subtitle">
                                        <p>Para completar el siguiente paso elige un rol formativo y a continuación puedes elegir dos tipos de cursos:</p>
                                    </div>
                                    <div className="container-course-notice">
                                        <div className="course-socio">
                                            <img src={competenciaEmocionalSVG} alt="competencia emocional" />
                                            <p>Un curso de competencias socioemocionales</p>
                                        </div>
                                        <div className="course-specific">
                                            <img src={competenciaEspecificaSVG} alt="competencia específica" />
                                            <p>Un curso de competencias específicas</p>
                                        </div>
                                    </div>

                                    <div className="a-button-magenta-container__modal-cancelar">
                                        <Button
                                            type="button"
                                            classname="a-button-magenta"
                                            text={"ENTENDIDO"}
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeNoticeModal()
                                            }}
                                        >
                                        </Button>
                                    </div>
                                </div>
                            </Modal>
                        )}
                        </FormBody>
                    </>
                </div>
            )}

            {/* Renderiza el modal */}
            {isOpenModalSuccess && (
                  <div className="modal-form-courses">
                    <div className="modal-form-courses-left">
                        <div className="modal-form-courses-left-container">
                            <h1 className="modal-form-courses-left-container__description">{contentfulModalSuccess.tituloPrincipal}</h1>
                            <p className="modal-form-courses-left-container__aux-text">Validaremos que cumplas con los requisitos, y si es así, nos pondremos en contacto contigo para comenzar tu proceso de aprendizaje.
                            Recuerda que tu segunda opción de curso será habilitada en caso de que tu primera elección no esté disponible.</p>
                        </div>

                        <div className="modal-form-courses-left__option-one">
                           <div className="modal-form-courses-left__option-one__main-container">
                              <p className="modal-form-courses-left__option-one__main-container__paraph">Opción 1:</p>
                           </div>
                           <div className="modal-form-courses-left__option-one__separator">
                              <div className="modal-form-courses-left__option-one__container">
                                 <strong className="modal-form-courses-left__option-one__container__enfoque">Enfoque:</strong>
                                 <p className="modal-form-courses-left__option-one__container__role">{selectedRole?.title}</p>
                              </div>
                              <div className="modal-form-courses-left__option-one__container-modality">
                                 <strong className="modal-form-courses-left__option-one__container-modality__modality">Modalidad:</strong>
                                 <p className="modal-form-courses-left__option-one__container__role">{formValues.modeSpecific}</p>
                              </div>
                              <div className="modal-form-courses-left__option-one__container-course">
                                 <strong className="modal-form-courses-left__option-one__container-course__course">Curso:</strong>
                                 <p className="modal-form-courses-left__option-one__container__role">{formValues.specific_curso.split("/")[0]}</p>
                              </div>
                           </div>
                        </div>

                        <div className="modal-form-courses-left__option-one">
                           <div className="modal-form-courses-left__option-one__main-container">
                              <p className="modal-form-courses-left__option-one__main-container__paraph">Opción 2:</p>
                           </div>
                           <div className="modal-form-courses-left__option-one__separator">
                              <div className="modal-form-courses-left__option-one__container">
                                 <strong className="modal-form-courses-left__option-one__container__enfoque">Enfoque:</strong>
                                 <p className="modal-form-courses-left__option-one__container__role">{selectedRole2?.title ? selectedRole2?.title : "No me interesa" }</p>
                              </div>
                              <div className="modal-form-courses-left__option-one__container-modality">
                                 <strong className="modal-form-courses-left__option-one__container-modality__modality">Modalidad:</strong>
                                 <p className="modal-form-courses-left__option-one__container__role">{formValues.modeSpecific2 ? formValues.modeSpecific2 : "No me interesa"}</p>
                              </div>
                              <div className="modal-form-courses-left__option-one__container-course">
                                 <strong className="modal-form-courses-left__option-one__container-course__course">Curso:</strong>
                                 <p className="modal-form-courses-left__option-one__container__role">{formValues.specific_curso_2 ? formValues.specific_curso_2.split("/")[0] : "No me interesa"}</p>
                              </div>
                           </div>
                        </div>
                        {
                           formValues.isInterested === "Si" && (
                              <div className="modal-form-courses-left__option-one">
                                 <div className="modal-form-courses-left__option-one__main-container">
                                    <p className="modal-form-courses-left__option-one__main-container__paraph">Tendrás la posibilidad de participar en:</p>
                                 </div>
                                 <div className="modal-form-courses-left__option-one__separator">
                                    <div className="modal-form-courses-left__option-one__container__presential">
                                       <strong className="modal-form-courses-left__option-one__container__enfoque">Curso:</strong>
                                       <p className="modal-form-courses-left__option-one__container__presential__course">Fluir con sentido para el desarrollo de competencias personales.</p>
                                    </div>
                                    <div className="modal-form-courses-left__option-one__container-modality">
                                       <strong className="modal-form-courses-left__option-one__container-modality__modality">Modalidad:</strong>
                                       <p className="modal-form-courses-left__option-one__container__role">Presencial</p>
                                    </div>
                                 </div>
                              </div>
                           )
                        }

                           <div className="courses__alert_courses">
                              <img
                                 className="courses__alert_courses__icon"
                                 alt="alert icon"
                                 src={iconInfo}
                              />
                              <span className="courses__alert_courses__text">
                                 Asistiendo a nuestros cursos estarás cumpliendo con uno de los requisitos para aplicar al
                                 <strong className="courses__alert_courses__text__subsidio" onClick={() => navigate(`https://www.comfama.com/servicio-de-empleo/personas/subsidio-de-desempleo/`)}> Subsidio al Desempleo.</strong>
                              </span>
                           </div>
                        <div>
                            <Button
                                type="link"
                                text={contentfulModalSuccess.tituloBoton}
                                href={contentfulModalSuccess.redireccionBoton}
                                isDisabled={false}
                                classname="modal-form-courses-left__button"
                                gtmMark="gtm_form_click_button_ver_vacantes"
                                data="Final inscripción cursos aprendizaje"
                            />
                        </div>
                    </div>
                    {/* <div className="modal-courses-right">
                        <img className="modal-courses-right__image" src={contentfulModalSuccess.imagenFormulario.file.url} />
                    </div> */}
                  </div>
            )}
            {isOpenModalNoInterest  && (
                <div className="modal-form-courses">
                    <div className="modal-form-courses-left">
                        <div>
                           <div>
                              <h1 className="modal-form-courses-left__description">{contentfulModalNoInterest.tituloPrincipal}</h1>
                              <span
                                 className="modal-form-courses-left__desc"
                              >
                                 {rawToReact(contentfulModalNoInterest.descripcionFormulario.raw,contentfulRenderOptions)}
                              </span>
                           </div>
                           <div className="modal-form-courses-left__buttons">
                              <Button
                                 type="button"
                                 classname="modal-form-courses-left__button"
                                 text="CONOCE NUESTROS SERVICIOS"
                                 isDisabled={false}
                                 onClickAction={() => closeForm()}
                              >
                              </Button>
                              <Button
                                 type="link"
                                 text={contentfulModalNoInterest.tituloBoton}
                                 href={contentfulModalNoInterest.redireccionBoton}
                                 isDisabled={false}
                                 classname="modal-form-courses-left__button-vacancies-white"
                              />
                           </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FormCursoAprendizaje;
